import { RedirectToSignIn, useAuth } from "@clerk/clerk-react";
import Loader from "components/common/loader";

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isLoaded, isSignedIn } = useAuth();

  if (!isLoaded) {
    return (
      <div>
        <Loader />
      </div>
    );
  }

  if (!isSignedIn) {
    return <RedirectToSignIn signInFallbackRedirectUrl={"/"} />;
  }

  return <>{children}</>;
}
